import dompurify from 'dompurify';

/**
 * This will take a node and select the given range of text from start to end in a
 * way that works for iOS
 * @param  {HTMLInputElement} node - the input to select the text in
 * @param  {Number} start - the index to start the selection
 * @param  {Number} end - the index to end the selection
 */
export function selectRangeOfText(node, start, end) {
	// select all the text, but do it on the next tick because iOS has issues otherwise
	setTimeout(() => {
		// we're using setSelectionRange rather than select because select doesn't work with iOS
		node.setSelectionRange(start, end)
	})
}

/**
 * This moves the cursor position to the end of the text in the input node in a way
 * that works on iOS
 * @param {HTMLInputElement} node - the input to set the cursor position in
 */
export function moveCursorToTheEnd(node) {
	const { length } = node.value
	node.setSelectionRange(length, length)
}

/**
 * Sanitizes HTML
 */
export function sanitize(input) {
	try {
		return dompurify.sanitize(escapeHtml(input));
	} catch (e) {
		return '';
	}
}

function escapeHtml(unsafe) {
	return unsafe
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
 }